import globalAgent from 'src/agent';

import { URLS } from '../../constants/urls';

export interface ISaveNicheAnalysisRequest {
    project_id: number;
    niche_analysis_keywords: string[];
    niche_analysis_category: string;
    niche_analysis_summary: string;
    selected_lead_ids?: number[];
    recommended_collections?: number[];
}

export interface ISaveNicheAnalysisResponse {
    message: string;
    project_id: number;
}

export interface ISaveSelectedLeadsRequest {
    project_id: number;
    selected_lead_ids: number[];
}

export interface ISaveSelectedLeadsResponse {
    message: string;
    project_id: number;
    selected_count: number;
}

export interface ISaveSelectedChatsRequest {
    project_id: number;
    selected_chat_ids: number[];
}

export interface ISaveSelectedChatsResponse {
    message: string;
    project_id: number;
    private_bundle_id: number;
    selected_count: number;
}

export interface ISaveSelectedCollectionsRequest {
    project_id: number;
    selected_collection_ids: number[];
}

export interface ISaveSelectedCollectionsResponse {
    message: string;
    project_id: number;
    selected_count: number;
}

class ProjectService {
    queryKey = 'project';

    async saveNicheAnalysis(data: ISaveNicheAnalysisRequest): Promise<ISaveNicheAnalysisResponse> {
        try {
            console.log('📡 Отправляем запрос на сохранение анализа ниши:', data);
            console.log('📡 URL:', URLS.SAVE_NICHE_ANALYSIS);
            const response = await globalAgent.post(URLS.SAVE_NICHE_ANALYSIS, data);
            console.log('✅ Ответ от API сохранения анализа ниши:', response.data);
            return response.data;
        } catch (error: any) {
            console.error('❌ Ошибка сохранения анализа ниши:', error);
            console.error('❌ Детали ошибки:', error.response?.data);
            console.error('❌ Статус:', error.response?.status);
            throw error;
        }
    }

    async saveSelectedLeads(data: ISaveSelectedLeadsRequest): Promise<ISaveSelectedLeadsResponse> {
        try {
            const response = await globalAgent.post(URLS.SAVE_SELECTED_LEADS, data);
            return response.data;
        } catch (error) {
            console.error('Ошибка сохранения выбранных лидов:', error);
            throw error;
        }
    }

    async saveSelectedChats(data: ISaveSelectedChatsRequest): Promise<ISaveSelectedChatsResponse> {
        try {
            const response = await globalAgent.post(URLS.SAVE_SELECTED_CHATS, data);
            return response.data;
        } catch (error) {
            console.error('Ошибка сохранения выбранных чатов:', error);
            throw error;
        }
    }

    async saveSelectedCollections(data: ISaveSelectedCollectionsRequest): Promise<ISaveSelectedCollectionsResponse> {
        try {
            const response = await globalAgent.post(URLS.SAVE_SELECTED_COLLECTIONS, data);
            return response.data;
        } catch (error) {
            console.error('Ошибка сохранения выбранных подборок:', error);
            throw error;
        }
    }

    async getProjectRecommendedCollections(projectId: number): Promise<{
        recommended_collections: Array<{ id: number; name: string; tags: string[]; location__name?: string }>;
    }> {
        try {
            const response = await globalAgent.get(
                `${URLS.GET_PROJECT_RECOMMENDED_COLLECTIONS}/${projectId}/recommended-collections/`
            );
            return response.data;
        } catch (error) {
            console.error('Ошибка получения рекомендованных подборок:', error);
            throw error;
        }
    }

    async getProjectFoundLeads(projectId: number): Promise<{
        found_leads: Array<{
            id: number;
            text: string;
            source: string;
            date: string;
            category: string;
            category_icon?: string;
            keywords: string[];
        }>;
    }> {
        try {
            const response = await globalAgent.get(
                `${URLS.GET_PROJECT_RECOMMENDED_COLLECTIONS}/${projectId}/found-leads/`
            );
            return response.data;
        } catch (error) {
            console.error('Ошибка получения найденных лидов:', error);
            throw error;
        }
    }

    async getProjectSelectedLeads(projectId: number): Promise<{
        selected_leads: Array<{
            id: number;
            message__text: string;
            message__source: string;
            message__date: string;
            category: string;
            category_icon?: string;
            message__keywords: string[];
        }>;
    }> {
        try {
            const response = await globalAgent.get(
                `${URLS.GET_PROJECT_RECOMMENDED_COLLECTIONS}/${projectId}/selected-leads/`
            );
            return response.data;
        } catch (error) {
            console.error('Ошибка получения выбранных лидов:', error);
            throw error;
        }
    }
}

export default new ProjectService();
